import React from 'react'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material'
import { TaskBoardType } from '../../types/task-board'
import { State } from '../../types/state'
import { getUserColor } from '../../utils/userColors'

interface TaskBoardTableProps {
  board: TaskBoardType
  filterMode: 'all' | 'assigned'
  userState: State['user']
  onCardClick: (columnId: string, cardId: string) => void
  onDueDateClick: (columnId: string, cardId: string) => void
  onDependencyClick: (columnId: string, cardId: string) => void
}

export const TaskBoardTable: React.FC<TaskBoardTableProps> = ({
  board,
  filterMode,
  userState,
  onCardClick,
  onDueDateClick,
  onDependencyClick
}) => {
  return (
    <TableContainer component={Paper} className='mt-4'>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tytuł</TableCell>
            <TableCell>Opis</TableCell>
            <TableCell>Kolumna</TableCell>
            <TableCell>Przypisany użytkownik</TableCell>
            <TableCell>Termin</TableCell>
            <TableCell>Komentarze</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {board.columns.flatMap(column =>
            column.cards
              .filter(card => filterMode === 'all' || ((card.assignedTo != null) && String(card.assignedTo.id) === String(userState.id)))
              .map(card => (
                <TableRow
                  key={card.id}
                  hover
                  onClick={() => onCardClick(column.id, card.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell>{card.title}</TableCell>
                  <TableCell>
                    {card.description.length > 100
                      ? `${card.description.substring(0, 100)}...`
                      : card.description}
                  </TableCell>
                  <TableCell>{column.title}</TableCell>
                  <TableCell>
                    {(card.assignedTo != null)
                      ? (
                        <div className='d-flex align-items-center'>
                          <div
                            className='rounded-circle mr-2 d-flex align-items-center justify-content-center'
                            style={{
                              width: '24px',
                              height: '24px',
                              backgroundColor: getUserColor(card.assignedTo.username),
                              color: 'white',
                              fontSize: '12px',
                              fontWeight: 'bold'
                            }}
                            title={card.assignedTo.username}
                          >
                            {card.assignedTo.username.charAt(0).toUpperCase()}
                          </div>
                        </div>
                        )
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {card.dueDate
                      ? (
                        <div className='d-flex align-items-center'>
                          <i className='fa fa-calendar mr-2' />
                          {new Date(card.dueDate).toLocaleString()}
                        </div>
                        )
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {card.comments.length > 0
                      ? (
                        <span>
                          <i className='fa fa-comment mr-1' />
                          {card.comments.length}
                        </span>
                        )
                      : '-'}
                  </TableCell>
                </TableRow>
              ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
